import {rial} from '../core/onlinePaymentApi'

/** Rials as the field shows them: Persian digits grouped by three. */
export const formatAmount = (value?: number) => (value === undefined ? '' : value.toLocaleString('fa-IR'))

// The grouping as digits are typed is every price field's now (apps/shared/amount, 60.11.501).
export {regroupAmount} from '../../apps/shared/amount/amountText'

/** «معادل ۵۰٬۰۰۰ تومان»: tomans cut down, so a reader never expects more than the rials say. */
export const tomanText = (amount: number) => `${rial(Math.floor(amount / 10))} تومان`

/** About how many one-part SMS a credit pays for; undefined while SMS has no price or is free for the business. */
export const smsCountFor = (credit: number, partPrice?: number, free?: boolean): number | undefined =>
  !free && partPrice && partPrice > 0 ? Math.floor(credit / partPrice) : undefined

/** Why an amount cannot be charged, or '' when it can. */
export const amountProblem = (amount: number | undefined, minimum: number, maximum: number): string => {
  if (amount === undefined || amount <= 0) return 'مبلغ شارژ را به ریال وارد کنید.'
  if (amount < minimum) return `کمترین مبلغ شارژ ${rial(minimum)} ریال است.`
  if (maximum > 0 && amount > maximum) return `بیشترین مبلغ شارژ ${rial(maximum)} ریال است.`
  return ''
}
